import axiosInstance from "../../translator";
import { rbacManagementAPI as rbac } from "../../constants/apis/apiEndpoints";
import { routeMapperFunction } from "../../utils";

export const fetchRolesList = async (urlParams) => {
  return axiosInstance
    .get(`${rbac?.rbacEndpoint}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchPermissionsList = async () => {
  return axiosInstance
    .get(`${rbac?.rbacPermissionEndpoint}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createNewRoleApi = async (data) => {
  return axiosInstance
    .post(`${rbac?.rbacEndpoint}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchRolePermissionsData = async (urlParams) => {
  return axiosInstance
    .get(`${rbac?.rbacRolePermissionsEndpoint}/${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const editRolePermissions = async (payload) => {
  return axiosInstance
    .put(`${rbac?.rbacRolePermissionsEndpoint}/${payload?.id}`, payload?.formData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchCloneRoles = async () => {
  return axiosInstance
    .get(`${rbac?.rbacClonedRoleEndpoint}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteSelectedRoleMapping = async (role_id) => {
  return axiosInstance
    .delete(`${rbac?.deleteRoleMapping}${role_id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteRole = async (role_id) => {
  return axiosInstance
    .delete(`${rbac?.rbacEndpoint}/${role_id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const resourcePermissions = async (roles) => {
  return axiosInstance
    .post(`${rbac?.resourcePermissionEndpoint}`, roles)
    .then((response) => {
      return {
        data: routeMapperFunction(response?.data?.results),
        status: response?.status,
      };
    })
    .catch((error) => {
      return error;
    });
};
